var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticClass:"change_column"},[_c('v-card',{staticClass:"single_section"},[_c('div',{staticClass:"font-weight-bold"},[_vm._t("title")],2),_c('div',[_vm._t("content")],2)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }